import { render, staticRenderFns } from "./Dialog_DiscountCourse.vue?vue&type=template&id=64aedf66&scoped=true&"
import script from "./Dialog_DiscountCourse.vue?vue&type=script&lang=js&"
export * from "./Dialog_DiscountCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aedf66",
  null
  
)

export default component.exports